import { useState, useEffect } from "react";
import { socket } from "./socket";

import { GoogleOAuthProvider } from "@react-oauth/google";
import Home from "./routes/Home";
import Jobs from "./routes/Jobs";
import NavBar from "./components/NavBar";
import SignUp from "./routes/SignUp";
import Properties from "./routes/Properties";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { APIProvider } from "@vis.gl/react-google-maps";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Provider } from "react-redux";
import store from "./store";
import SignIn from "./routes/SignIn";
import Assignments from "./routes/Assignments";
import Messages from "./routes/Messages";
import Settings from "./routes/Settings";

export default function App() {
  const [isConnected, setIsConnected] = useState(socket.connected); //eslint-disable-line
  const [messageEvents, setMessageEvents] = useState([] as any[]);

  useEffect(() => {
    function onConnect() {
      setIsConnected(true);
    }

    function onDisconnect() {
      setIsConnected(false);
    }

    function onMessageEvent(value: any) {
      setMessageEvents((previous) => [...previous, value]);
    }

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    socket.on("message", onMessageEvent);

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off("message", onMessageEvent);
    };
  }, []);

  return (
    <div className="App">
      <Provider store={store}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <GoogleOAuthProvider
            clientId={process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID || ""}
          >
            <APIProvider
              apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""}
              onLoad={() => console.log("Maps API has loaded.")}
            >
              <BrowserRouter>
                <div>
                  <NavBar/>
                    
                  <div style={{position: 'absolute', top: '112px', width: '100%'}}>
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/jobs/*" element={<Jobs />} />
                      <Route path="/sign-up" element={<SignUp />} />
                      <Route path="/sign-in" element={<SignIn />} />
                      <Route path="/properties" element={<Properties />} />
                      <Route path="/settings" element={<Settings />} />
                      <Route path="/assignments/*" element={<Assignments />} />
                      <Route
                        path="/messages"
                        element={<Messages messageEvents={messageEvents} />}
                      />
                    </Routes>
                  </div>
                </div>
              </BrowserRouter>
            </APIProvider>
          </GoogleOAuthProvider>
        </LocalizationProvider>
      </Provider>
    </div>
  );
}
